module.exports = "<div class=\"d3-chart-title\"><h6>{{reportTitle}}</h6></div>\r\n<div class=\"d3-chart\" #pyramidchart></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pyramid-chart/pyramid-chart.component.html
// module id = ./src/app/pyramid-chart/pyramid-chart.component.html
// module chunks = main